<template>
  <BaseModal id="modal-delete-sub-lo" title="Delete this sub learning outcome" :show.sync="$show">
    <p class="text-black-50">Are you sure that you want to delete this sub learning outcome?</p>
    <b-alert variant="danger" show>{{ title }}</b-alert>
    <p class="text-black-50">Click at the “Delete” button to delete this sub learning outcome.</p>
    <template #modal-footer>
      <div class="d-flex justify-content-end w-100">
        <b-button
          id="button-cancel"
          variant="link"
          class="btn-link-dark"
          :disabled="disabled"
          @click="hide()"
        >
          Cancel
        </b-button>
        <b-button id="button-delete" variant="danger" :disabled="disabled" @click="handleDelete()">
          <b-spinner v-if="submitting" />
          <span v-else> Delete</span>
        </b-button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { BaseModal } from '@/components/base-components';
import { LearningOutcome } from '@/models/LearningOutcome';
import { Criteria } from '@/models';
export default {
  components: {
    BaseModal
  },

  props: {
    ultimateLearningOutcome: {
      type: LearningOutcome,
      required: true
    },

    subLearningOutcome: {
      type: LearningOutcome,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      title: '',
      disabled: false,
      submitting: false
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    }
  },

  watch: {
    show: {
      immediate: true,
      handler(show) {
        if (show) {
          this.title = this.subLearningOutcome ? this.subLearningOutcome.title : '';
        }
      }
    }
  },

  methods: {
    async handleDelete() {
      try {
        this.disabled = true;
        this.submitting = true;

        if (this.subLearningOutcome) {
          let { properties = '{}' } = this.ultimateLearningOutcome;

          properties = JSON.parse(properties);

          const { order = [] } = properties;

          const orderIndex = order.findIndex(
            (subOrder) =>
              subOrder.id == this.subLearningOutcome.id && subOrder.model == 'learning-outcomes'
          );

          if (orderIndex !== -1) {
            order.splice(orderIndex, 1);
          }

          await Promise.all([
            LearningOutcome.api().deleteSubLearningOutcome(this.subLearningOutcome.id),
            LearningOutcome.api().updateProperties(this.ultimateLearningOutcome.id, {
              ...properties,
              order
            })
          ]);

          this.$toast.success(`The sub learning outcome was deleted successfully`);

          this.subLearningOutcome.criterion_ids.forEach((criterion_id) => {
            Criteria.delete(criterion_id);
          });
          this.$emit('onSubLearningOutcomeDeleted', [...this.subLearningOutcome.criterion_ids]);
        } else {
          this.$toast.error(`Cannot delete sub learning outcome`);
        }
        this.hide();
      } catch (error) {
        this.disabled = false;

        this.$toast.error(`Cannot delete sub learning outcome`);
      } finally {
        this.disabled = false;
        this.submitting = false;
      }
    },
    hide() {
      this.$bvModal.hide(`modal-delete-sub-lo`);
    }
  }
};
</script>

<style lang="scss" scoped></style>
